<div class="print-label">
  <div class="row no-gutters">
    <div class="print-label__printing-parameters col" [ngClass]="{ 'print-label__printing-parameters--collapsible': collapsible }">
      <app-print-label-header
        [isPalletFinished]="isPalletFinished"
        [printerName]="printInfo.printerName"
        [printedLabels]="printInfo.printedOutputUnits"
        [labelsTotal]="printInfo.totalOutputUnits"
        [quantityPerOuter]="printInfo.quantityPerOuter"
        [defaultQuantityPerOuter]="printInfo.defaultQuantityPerOuter"
        [collapsible]="collapsible"
        [labelType]="printInfo.labelType"
        [numberOfCopies]="numberOfCopies"
        [isQuantityPerOuterValid]="isQuantityPerOuterValid"
        [producedMaterialId]="producedMaterialId"
        [palletQuantity]="palletQuantity"
        [isBobbin]="isBobbin"
        [isQuantityPerOuterChangeInProgress]="isQuantityPerOuterChangeInProgress"
        (toggleButtonClicked)="toggleContent($event)"
        (quantityPerOuterChanged)="onQuantityPerOuterChange($event)"
        (numberOfCopiesChanged)="onNumberOfCopiesChanged($event)"
        (quantityPerOuterInput)="onQuantityPerOuterInput($event)"
      ></app-print-label-header>

      <div *ngIf="!isCollapsed" class="printing-parameters">
        <app-print-label-range
          [isPalletFinished]="isPalletFinished"
          [collapsible]="collapsible"
          [labelsTotal]="printInfo.totalOutputUnits"
          [printedLabels]="printInfo.printedOutputUnits"
          [title]="isBobbin === true ? 'OUTPUT_UNIT.PRINT_BOBBIN' : 'OUTPUT_UNIT.PRE_PRINT'"
          [labelType]="printInfo.labelType"
          [isQuantityPerOuterValid]="isQuantityPerOuterValid"
          [quantityPerOuter]="quantityPerOuter"
          [isPrintLabelRequestInProgress]="isPrintLabelRequestInProgress"
          (okButtonClicked)="printLabel($event)"
          (okBobbinButtonClicked)="printBobbinCoreLabel($event)"
          [isBobbin]="isBobbin"
        ></app-print-label-range>
        <app-print-label-range
          [isPalletFinished]="isPalletFinished"
          [collapsible]="collapsible"
          [labelsTotal]="printInfo.totalOutputUnits"
          [printedLabels]="printInfo.printedOutputUnits"
          [isReprint]="true"
          [title]="'OUTPUT_UNIT.RE_PRINT'"
          [labelType]="printInfo.labelType"
          [isQuantityPerOuterValid]="isQuantityPerOuterValid"
          [quantityPerOuter]="quantityPerOuter"
          [isPrintLabelRequestInProgress]="isPrintLabelRequestInProgress"
          (okButtonClicked)="printLabel($event)"
          (okBobbinButtonClicked)="printBobbinCoreLabel($event)"
          [isBobbin]="isBobbin"
        ></app-print-label-range>
      </div>
    </div>
  </div>
</div>
